import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import i18n from './src/site/i18n';
import { I18nextProvider } from 'react-i18next';
import { Layout } from '@components/Layout';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
);

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
);
